import React from 'react';
import '../../../css/Form.css';
import CurrentAddress from './CurrentAddress';
import PermanentAddress from './PermanentAddress';
import ERPUtils from '../../../helper/Utils'

const AddressDetails = (props) => {
	// used States:
	const {
		userDetails,
		onChangeHandler,
		checkboxHandler,
		saveDraft,
		handleRenderComp,
		ValidationError,
		currentCities,
		permanentCities,
		statesCur,
		statesPer,
		SelectHandler,
		countries,
		topFunction,
		scrollToBottom,
		requiredFields,
		GenerateRemovePopup,
		dashboardHandler,
		LockDashboard,
		scrollHandler
	} = props;

	const getStateFromPincodeData = (city, stateId, cityId) => {
		if (!ERPUtils.isNullOrEmpty(city)) {
			for (let index = 0; index < city.length; index++) {
				const element = city[index];
				if (element.value === parseInt(cityId, 10) && element.stateDto.value === stateId) {
					return element.stateDto
				}
			}
		}
		return "";
	}

	return (
		<div className="appForm" id='APP-FORM' onScroll={scrollHandler} 
		style={{height:window.innerWidth>800 ? window.innerHeight-240 : window.innerWidth<=375?window.innerHeight-275:window.innerWidth<=425?window.innerHeight-260: window.innerHeight-260,overflowY:"auto"}}>
			<div className="animated zoomIn">
				<div className="row">
					<div className="col-md-6 col-sm-6">
						{/* <button
							className={LockDashboard ? 'disabledDashboardBtn' : 'backtoDashboardBtn'}
							onClick={dashboardHandler}
							disabled={LockDashboard}
						>
							<i className="fa fa-arrow-left backIcon" />Back to dashboard
						</button> */}
					</div>
					<div className="col-md-6 col-sm-6">
						<p className="requiredHeader ">
							<span className="requiredTextHeading">*</span> These fields are required
						</p>
					</div>
				</div>
				<CurrentAddress
					userDetails={userDetails}
					onChangeHandler={onChangeHandler}
					ValidationError={ValidationError}
					cities={currentCities}
					states={statesCur}
					countries={countries}
					SelectHandler={SelectHandler}
					requiredFields={requiredFields}
					GenerateRemovePopup={GenerateRemovePopup}
					getStateFromPincodeData={getStateFromPincodeData}
				/>
				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3">&nbsp;</div>
						<div className="col-md-9">
							<div className="checkbox">
								<label>
									<input
										type="checkbox"
										name="curAddSameAsPer"
										onChange={checkboxHandler}
										checked={userDetails.curAddSameAsPer === 'Yes' ? true : false}
									/>
									 Permanent address same as current address.
								</label>
							</div>
						</div>
					</div>
				</div>
				{userDetails.curAddSameAsPer === 'Yes' ? null : (
					<PermanentAddress
						userDetails={userDetails}
						onChangeHandler={onChangeHandler}
						ValidationError={ValidationError}
						cities={permanentCities}
						states={statesPer}
						countries={countries}
						SelectHandler={SelectHandler}
						requiredFields={requiredFields}
						GenerateRemovePopup={GenerateRemovePopup}
						getStateFromPincodeData={getStateFromPincodeData}
					/>
				)}
				<br />
				<div className="formWrapper">
					<div className="row">
						<div className="col-sm-4 parentDiv">
							<button
								className="PreviousButton z-depthButton"
								value="Previous"
								name="PersonalDetails"
								onClick={()=>handleRenderComp("PersonalDetails")}
							>
								<i className="fas fa-chevron-left mr-3" style={{ color: "#ffffff" }}></i>
								Previous
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button
								className="saveDraftButton z-depthButton"
								value="Save Draft"
								name="SaveDraft"
								onClick={saveDraft}
							>
								Save Draft
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button
								className="nextButton z-depthButton"
								value="Next"
								name="EducationDetails"
								onClick={()=>handleRenderComp("EducationDetails")}
							>
								Next
								<i className="fas fa-chevron-right ml-4 mt-1" style={{ color: "#ffffff" }}></i>
							</button>
						</div>
					</div>
				</div>
				<button onClick={topFunction} id="myBtnUp">
					<div className="UpArrow" />
				</button>
				<button onClick={scrollToBottom} id="myBtnDown">
					<div className="downArrow" />
				</button>
			</div>
		</div >
	);
};

export default AddressDetails;
